var exports = {
  "Pf": "xa15a2ab7--948d3e--label",
  "wm": "xa15a2ab7--948d3e--logo",
  "_8": "xa15a2ab7--948d3e--img",
  "cL": "xa15a2ab7--948d3e--builder",
};

module.exports = exports;
